namespace Roodik.Game
{
	import ViewBase = Roodik.Core.ViewBase;
	
	export class IconView extends ViewBase
	{
		constructor(type:string)
		{
			super(type);
			
			this.x = 4;
			this.y = -12;
			this.rotation = -0.42;
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Game/View/Board/IconView.ts